import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

function BentoGrid({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "grid w-full auto-rows-[22rem] grid-cols-3 gap-4",
        className
      )}
    >
      {children}
    </div>
  );
}

function BentoCard({
  name,
  className,
  background,
  Icon,
  description,
  comingSoon,
}: {
  name: string;
  className?: string;
  background?: ReactNode;
  Icon?: React.ElementType;
  description: string;
  comingSoon?: boolean;
}) {
  return (
    <div
      className={cn(
        "group relative col-span-3 flex flex-col justify-between overflow-hidden rounded-xl",
        "bg-card border-border border shadow-sm",
        "transform-gpu transition-all duration-300",
        className
      )}
    >
      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
        {background}
      </div>
      {comingSoon && (
        <div className="absolute top-4 right-4 z-20">
          <span className="bg-muted text-muted-foreground rounded-full px-2.5 py-1 text-xs font-medium">
            Coming Soon
          </span>
        </div>
      )}
      <div className="z-10 flex flex-col gap-1 p-6 transition-all duration-300">
        {Icon && (
          <Icon className="text-brand mb-2 size-10 origin-left transform-gpu transition-all duration-300 ease-in-out group-hover:scale-75" />
        )}
        <h3 className="text-foreground text-lg font-semibold">{name}</h3>
        <p className="text-muted-foreground max-w-lg text-sm">{description}</p>
      </div>
    </div>
  );
}

export { BentoGrid, BentoCard };
